import { useQuery } from '@tanstack/react-query';

import type { ListParams } from '../api/resources';
import type { PaginatedResult } from '../types/api';

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_SORT = JSON.stringify([{ field: 'createdAt', order: 'DESC' }]);

export function useListQuery<T>(
    key: string,
    fetcher: (params: ListParams) => Promise<PaginatedResult<T>>,
    params: ListParams,
) {
    return useQuery({
        queryKey: [key, params],
        queryFn: () =>
            fetcher({
                limit: DEFAULT_PAGE_SIZE,
                sort: DEFAULT_SORT,
                ...params,
            }),
    });
}
